import { Translations } from "@aws-amplify/ui-components";
import { Authenticator } from "@aws-amplify/ui-react";
import { DefaultComponents } from "@aws-amplify/ui-react/dist/types/components/Authenticator/hooks/useCustomComponents/defaultComponents";
import { createStyles, Stack } from "@mantine/core";
import { RpiCheckboxV2, RpiLabelText, RpiTitle } from "@rpi/openapi-core";
import { I18n } from "aws-amplify";
import { PublicUrl } from "../../../utils/link.util";
import { useState } from "react";
import { getRoutePath } from "../../../hooks/useNavigateRoute";
import { RpaNavLink, RpaOutLink } from "../../../components/RpiLink";

const useSignUpStyles = createStyles((theme) => ({
  authHeader: {
    alignItems: "center",
    gap: theme.spacing.md,
    marginBottom: theme.spacing.md,
  },
  authFooter: {
    alignItems: "center",
    gap: theme.spacing.md,
    marginTop: theme.spacing.md,
  },
}));

export const signUpComponent: DefaultComponents["SignUp"] = {
  Header() {
    const { classes } = useSignUpStyles();
    return (
      <Stack className={classes.authHeader}>
        <img src="/logo.svg" width={94} height={94} alt="RPI Logo" />
        <RpiTitle>Welcome to RPI Print API!</RpiTitle>
        <RpiLabelText>Please enter your information below.</RpiLabelText>
      </Stack>
    );
  },
  FormFields() {
    const [showError, setShowError] = useState<boolean>(false);
    const tncErrorText = "Please check this box to accept our Terms & Conditions";

    return (
      <>
        <Authenticator.SignUp.FormFields />
        <RpiCheckboxV2
          aria-invalid="false"
          name="acknowledgement"
          data-testid={"termsCheckbox"}
          required
          error={showError ? tncErrorText : undefined}
          onInvalid={() => {
            setShowError(true);
          }}
          onChange={(event) => {
            setShowError(!event.currentTarget.checked);
          }}
          label={
            <>
              I agree to RPI Print API's{" "}
              <RpaOutLink href={PublicUrl.TERMS_AND_CONDITIONS} target="_blank" variant="inline">
                Terms & Conditions
              </RpaOutLink>
              .
            </>
          }
        />
      </>
    );
  },
  Footer() {
    const { classes } = useSignUpStyles();
    return (
      <Stack className={classes.authFooter}>
        <RpaNavLink to={getRoutePath("auth:sign-in")}>I already have an account</RpaNavLink>
      </Stack>
    );
  },
};

I18n.putVocabulariesForLanguage("en", {
  [Translations.CONFIRM_SIGN_UP_SUBMIT_BUTTON_TEXT]: "Submit",
  // overriding cognito errors like this is very fragile, it will break if the base string changes,
  // but there aren't really better options
  "Password did not conform with policy: Password not long enough": "Your password must be at least 8 characters long",
  "Password did not conform with policy: Password must have numeric characters":
    "Your password must include at least one number",
  "Password did not conform with policy: Password must have lowercase characters":
    "Your password must include at least one lowercase letter",
  "1 validation error detected: Value at 'password' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[\\S]+.*[\\S]+$":
    "Your password cannot begin or end with a space",
});
